__turbopack_context__.v({
  "accessibleText": "HeroCarousel-module-scss-module__QHMyqa__accessibleText",
  "active": "HeroCarousel-module-scss-module__QHMyqa__active",
  "carouselViewport": "HeroCarousel-module-scss-module__QHMyqa__carouselViewport",
  "carouselWrapper": "HeroCarousel-module-scss-module__QHMyqa__carouselWrapper",
  "controlButton": "HeroCarousel-module-scss-module__QHMyqa__controlButton",
  "eds-vector-image": "HeroCarousel-module-scss-module__QHMyqa__eds-vector-image",
  "imageList": "HeroCarousel-module-scss-module__QHMyqa__imageList",
  "imageListItem": "HeroCarousel-module-scss-module__QHMyqa__imageListItem",
  "next": "HeroCarousel-module-scss-module__QHMyqa__next",
  "prev": "HeroCarousel-module-scss-module__QHMyqa__prev",
  "sliderBar": "HeroCarousel-module-scss-module__QHMyqa__sliderBar",
  "sliderBarButton": "HeroCarousel-module-scss-module__QHMyqa__sliderBarButton",
  "sliderBarList": "HeroCarousel-module-scss-module__QHMyqa__sliderBarList",
});
